import { render } from "./ClaimsInsightComponent.vue?vue&type=template&id=7af8835a&scoped=true"
import script from "./ClaimsInsightComponent.vue?vue&type=script&lang=js"
export * from "./ClaimsInsightComponent.vue?vue&type=script&lang=js"

import "./ClaimsInsightComponent.vue?vue&type=style&index=0&id=7af8835a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af8835a"]])

export default __exports__